import React from "react";
import userimg from "../../assets/images/user.png";

const JobsPage = () => {
  return (
    <div>
      <div className="container-box">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>Job Details</h2>
        </div>
        <div className="outer-white job-details-page">
          <div className="row">
            <div className="col-xl-5 col-lg-8">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <img src={userimg} className="round-img" alt=""/>
                  <p className="mb-0 dark-textss">Jone Doe</p>
                </div>
                <h3>House Drone Photography for my home</h3>
                <p className="light-texts">Destination</p>
                <address className="dark-textss">
                  3448 Ile De France St #24232, Fort Wainwright, Alaska 9971203,
                  USA
                </address>
                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <p className="light-texts">Required Date</p>
                      <p className="dark-textss">MAR 1, 2023</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <p className="light-texts">Area Size (sq/ft)</p>
                      <p className="dark-textss">50</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-4 mt-4">
            <h6 className="light-texts">Description</h6>
            <div className="d-flex gap-2 flex-wrap">
              <span className="blue-bedge">Thermal Imaging</span>
              <span className="blue-bedge">Pipe Lines</span>
              <span className="blue-bedge">Thermal Home Inspections</span>
              <span className="blue-bedge">Solar Farms</span>
            </div>
          </div>
          <div className="details-para">
            <h6 className="light-texts">Description</h6>
            <p>
              We are looking for a highly organized and detail-oriented Drone
              Booking Specialist to manage our drone booking operations. In this
              role, you will be responsible for scheduling and coordinating
              drone flights for a variety of purposes, including aerial
              photography, surveying, and inspection.
            </p>
          </div>
          <div className="details-para">
            <h6 className="light-texts">Description</h6>
            <p>
              Make sure you have a drone that is capable of taking high-quality
              video and images. Check the drone's specifications to see if it
              has a good camera, stabilisation features, and a long battery
              life.
            </p>
          </div>
          <hr />
          <div className="details-para">
            <h6 className="light-texts">Estimation (days)</h6>
            <p>5</p>
          </div>
          <div className="details-para">
            <h6 className="light-texts">Message</h6>
            <p>
              We are looking for a highly organized and detail-oriented Drone
              Booking Specialist to manage our drone booking operations. In this
              role, you will be responsible for scheduling and coordinating
              drone flights for a variety of purposes, including aerial
              photography, surveying, and inspection.
            </p>
          </div>
          <hr />
          <div className="d-flex flex-wrap justify-content-between">
            <div className="d-flex gap-3 amount-div">
              <h5 >Final Approved Amount ($)</h5>
              <p >470</p>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <a href="/" className="btn gray-btnn">
                View Files
              </a>
              <a href="/" className="btn blue-btnnn text-white">
                Download Report
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsPage;
